/** A rejected saved-search write, carrying the JSON:API error code alongside its title. */
export class SavedSearchRequestError extends Error {
  code: string;

  constructor(message: string, code: string) {
    super(message);
    this.name = 'SavedSearchRequestError';
    this.code = code;
  }
}
